// 19.1.3.10 Object.is(value1, value2)
var $export = require('./$.export');
$export($export.S, 'Object', {is: require('./$.same-value')});


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/es6.object.is.js
 ** module id = 766
 ** module chunks = 0
 **/